import { defineMessages } from 'react-intl-next';

export default defineMessages({
	spellingAndGrammarButtonLabel: {
		id: 'fabric.editor.ai.spellingAndGrammarButton.tooltip',
		defaultMessage: 'Spelling and grammar check',
		description: 'The tooltip text for the spelling and grammar button in the Editor toolbar',
	},
});
